import React, { useEffect, useState } from 'react';
import DefaultSelect from '../DefaultSelect';
import MultiSelect from '../MultiSelect';
import BaseService from '../../services/BaseService';

const MunicipioSelect = ({ onSelect, value, isRequired, error, helperText, disabled, multiSelect }) => {
  const [optionsByCode, setOptionsByCode] = useState([]);
  
  const getOptions = async () => {
    try {
      const response = await BaseService.get({ url: 'options/municipios' });
      if (multiSelect) {
        setOptionsByCode(response.data.map(o => ({value: o.codigoIbge, label: o.nome})));
      } else {
        setOptionsByCode(response.data.map(o => ({id: o.codigoIbge, nome: o.nome})));
      }
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    getOptions();
  }, []);

  if (multiSelect) {
    return (
      <MultiSelect
        label='Cidades'
        onChange={values => {
          onSelect(values ? values.map(v => v.value) : null)
        }}
        value={value}
        options={optionsByCode}
      />
    )
  }

  return (
    <DefaultSelect 
      error={error}
      helperText={helperText}
      isRequired={isRequired}
      label='Cidades'
      onSelect={event => onSelect(event.target.value, event.target.options[event.target.selectedIndex].text)}
      options={optionsByCode}
      value={value}
      disabled={disabled}
    />
  );
}

export default MunicipioSelect;